import { useTranslation } from "react-i18next";

import { CaptainAvatar } from "./CaptainAvatar";

export function CaptainEmptyState({ userName }: { userName: string }) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 px-6 text-center">
      <CaptainAvatar size="lg" />
      <div className="space-y-2">
        <h3 className="text-lg font-semibold">
          {t("captain.greeting", { name: userName })}
        </h3>
        <p className="text-sm text-muted-foreground">
          {t("captain.subtitle")}
        </p>
      </div>
    </div>
  );
}
